const getDateUtil = (day=0, month=0, year=0) => {
    let date = new Date();
    date.setDate(date.getDate() + day);
    date.setMonth(date.getMonth() + month);
    date.setFullYear(date.getFullYear() + year);
    return date
}

const addDaysToDate = (date, days) => {
    if (!date || !Number.isFinite(days)) return null;
    const result = new Date(date);
    if (Number.isNaN(result.getTime())) return null;
    result.setDate(result.getDate() + days);
    return result;
}

const DirFormat = (date) => {
    if (!date || isNaN(date.getTime?.())) {
        return null;
    }
    return date.toLocaleDateString("en-US", {
        month: "short",
        year: "numeric"
    });
}

const dateFormator = (date, format={type: "en-uk"}, delim="/") => {
    if (format.type === 'input-format') {
        if (!date || isNaN(date.getTime?.())) {
            return null;
        }
        const options = { month: "short", day: "numeric" };
        if (format.year !== false) options.year = "numeric";
        return date.toLocaleDateString(format.locale || "en-US", options);
    }
    let day = String(date.getDate()).padStart(2, "0");       
    let month = String(date.getMonth() + 1).padStart(2, "0"); 
    let year = date.getFullYear();
    if(format.year === "short") year%=100;    
    
    if(format.type === "datepicker_object") {
        return date;
    }else if(format.type==="en-uk"){
        return day + delim + month + delim + year
    }else if(format.type === "en-us"){
        return month + delim + day + delim + year
    }else if(format.type === "custom"){
        let arr = format.format.split("-");
        let date_str = arr.map(e => {
            if(e === "dd") return day;
            if(e === "mm") return month;
            if(e === "yyyy") return year;
        }).join(delim);
        return date_str
    }

    return date.toLocaleDateString().replaceAll("/", delim)
}

const datepicker_input_format = (date, format="dd-mm-yyyy", delim="-") => {
    return dateFormator(date,{type:"en-uk"},delim);
}
const getMonthName = (monthNumber) => {
    const date = new Date();
    date.setMonth(monthNumber - 1);
  
    return date.toLocaleString('en-US', { month: 'short' });
}
const checkValidDateString = (str, delim="-") => {
    if(!str) return NaN;
    // String should be in dd-mm-yyyy format
    return Date.parse(str.split(delim).reverse().join("-"));
}
const currentYear = new Date().getFullYear()
const currentMonth = new Date().getMonth()

const generateYears = (past_years) => {
    const years = [];
    for (let year = currentYear; year >= currentYear - past_years; year--) {
      years.push(year);
    }
    return years;
  };

const convertMonthYearToDate = ({ month, year }) => {
  return new Date(year, month - 1, 1); // month: 1-indexed
};
 
export {getDateUtil, addDaysToDate, dateFormator, getMonthName, datepicker_input_format, checkValidDateString, currentYear, currentMonth, generateYears, convertMonthYearToDate, DirFormat}
